import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Minus = createSvgIcon(
  () => (
    <path d="M36.7188 0H0.78125C0.292969 0 0 0.390625 0 0.78125V3.90625C0 4.39453 0.292969 4.6875 0.78125 4.6875H36.7188C37.1094 4.6875 37.5 4.39453 37.5 3.90625V0.78125C37.5 0.390625 37.1094 0 36.7188 0Z" />
  ),
  '0 0 38 4.7'
);
